// TODO: Twitter/X is temporarily disabled. CHARACTERS_LIMIT_TWITTER_MESSAGE may be deleted later.
import { CHARACTERS_LIMIT_FB_MESSAGE, MESSAGE_LINK_PLACEHOLDER } from '@/constants';

export const getPreviewPrefix = (organizationName: string, groupName?: string | null): string => {
  return `${organizationName}${groupName ? `-${groupName}` : ''}: `;
};

export const getImageFromHtml = (html: string): string | null => {
  if (!html) return null;
  const imgRegex = /<img[^]+src="([^">]+)"/i;
  const match = html.match(imgRegex);

  return match ? match[1] : null;
};

export const hasBase64Image = (html: string | null | undefined): boolean => {
  if (!html) return false;
  return /data:image\/[a-zA-Z0-9.+-]+;base64,/i.test(html);
};

export const FBCutter = (htmlContent: string, attachmentsCount: number = 0): string => {
  const text = getTextFromHtml(htmlContent, true);
  const isMultiImg = hasMultipleImages(htmlContent, attachmentsCount);
  const isContainLinks = hasLinksInOriginal(htmlContent);

  let result = text;
  if (isMultiImg || isContainLinks || (text && text.length > CHARACTERS_LIMIT_FB_MESSAGE)) {
    const tailText = `${text.length > 0 ? '... ' : ''}Read more at ${MESSAGE_LINK_PLACEHOLDER}`;
    const cutMessage = text.substring(0, CHARACTERS_LIMIT_FB_MESSAGE - tailText.length);
    result = `${cutMessage}${tailText}`;
  }

  return result.replace(/^\s+|\s+$/g, '').replace(/(\r?\n\s*)+/g, '\n');
};

// TODO: Twitter/X is temporarily disabled. This code may be deleted later.
// export const TwitterCutter = (htmlContent: string, attachmentsCount: number = 0): string => {
//   const text = getTextFromHtml(htmlContent, true);
//   const isMultiImg = hasMultipleImages(htmlContent, attachmentsCount);
//   const isContainLinks = hasLinksInOriginal(htmlContent);

//   let result = text;
//   if (isMultiImg || isContainLinks || (text && text.length > CHARACTERS_LIMIT_TWITTER_MESSAGE)) {
//     const tailText = `${text.length > 0 ? '... ' : ''}Read more at ${MESSAGE_LINK_PLACEHOLDER}`;
//     const cutMessage = text.substring(0, CHARACTERS_LIMIT_TWITTER_MESSAGE - tailText.length);
//     result = `${cutMessage}${tailText}`;
//   }

//   return result.replace(/^\s+|\s+$/g, '').replace(/(\r?\n[ \t]*){3,}/g, '\n');
// };

export const SMSCutter = (
  _htmlContent: string,
  _prefixLength: number,
  subject: string | null | undefined,
  actionText: string
): { content: string; isShortMode: boolean } => {
  const subjectText = subject ? `${subject}-` : '';
  return { content: `${subjectText}${actionText}: ${MESSAGE_LINK_PLACEHOLDER}`, isShortMode: true };
};

export const getTextFromHtml = (html: string, ignoreHref: boolean = false): string => {
  if (!html) return '';

  let text = html;

  if (ignoreHref) {
    text = text.replace(/<a\b[^>]*>(.*?)<\/a>/gi, '');
  }

  text = text.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');
  text = text.replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '');
  text = text.replace(/<!--[\s\S]*?-->/g, '');
  text = text.replace(/<br\s*\/?>/gi, '\n');
  text = text.replace(/<\/(p|div|h[1-6]|li|ul|ol|tr|blockquote|section|article|header|footer)>/gi, '\n');
  text = text.replace(/<[^>]*>/g, '');

  text = text
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");

  return text.trim();
};

const hasMultipleImages = (html: string, attachmentsCount: number = 0): boolean => {
  if (!html && attachmentsCount === 0) return false;
  const imgRegex = /<img[^>]*>/gi;
  const matches = html ? html.match(imgRegex) : null;
  const htmlImagesCount = matches ? matches.length : 0;

  return htmlImagesCount + attachmentsCount > 1;
};

const hasLinksInOriginal = (html: string): boolean => {
  if (!html) return false;
  const textWithLinks = getTextFromHtml(html, false);
  const textWithoutLinks = getTextFromHtml(html, true);

  return textWithLinks.length !== textWithoutLinks.length;
};
